<template>
  <div>
    <div class="DataGrid-BOX">
      <!-- 查询-简易查询 -->
      <Form class="formbox-simple" v-if="displayQuery && searchShow && searchType === '02'" :label-width="labelWidth" @submit.native.prevent>
        <div class="searchBox steylehang" style="float: left">
          <div v-for="(condi, idx) in queryFields[0]" :key="idx">
            <FormItem :label="condi.description + '：'">
              <slot :name="condi.queryId" v-if="$scopedSlots[condi.queryId]" :condi="condi"></slot>
              <template v-else>
                <template v-if="condi.controlTypeName === '02' && (condi.dicType === '0' || condi.dicType === '1')">
                  <!--字典组件-->
                  <s-dicgrid
                    v-model="condi.searchValue"
                    :style="{ width: condi.width ? condi.width + 'px' : '100%' }"
                    ref="dicGrid"
                    :key="idx"
                    :multiple="condi.isDicMultiple"
                    :dicName="condi.dicInfo"
                  />
                </template>
                <template v-else-if="condi.controlTypeName === '02' && condi.dicType === '3'">
                  <!--字典组件(下拉框)-->
                  <Select v-model="condi.searchValue" :style="{ width: condi.width ? condi.width + 'px' : '100%' }" :multiple="condi.isDicMultiple" clearable placeholder="请选择">
                    <Option v-for="item in condi.option" :value="item.key" :key="item.key">{{ item.text }}</Option>
                  </Select>
                </template>
                <template v-else-if="condi.controlTypeName === '03' && condi.opName === 'between'">
                  <!--日期组件-->
                  <Row>
                    <Col>
                      <el-date-picker
                        popper-class="DataGrid-BOX"
                        :picker-options="pickerOptions(condi, 1)"
                        :style="{ width: condi.width ? condi.width + 'px' : '150px' }"
                        :format="condi.format"
                        value-format="yyyy-MM-dd"
                        size="small"
                        v-model="condi.start"
                        type="date"
                        placeholder="开始日期"
                      ></el-date-picker>
                    </Col>
                    <Col style="text-align: center" class="timeTextzhi">&nbsp;至&nbsp;</Col>
                    <Col>
                      <el-date-picker
                        popper-class="DataGrid-BOX"
                        :picker-options="pickerOptions(condi, 2)"
                        :style="{ width: condi.width ? condi.width + 'px' : '150px' }"
                        :format="condi.format"
                        value-format="yyyy-MM-dd"
                        size="small"
                        v-model="condi.end"
                        type="date"
                        placeholder="结束日期"
                      ></el-date-picker>
                    </Col>
                  </Row>
                </template>
                <template v-else-if="condi.controlTypeName === '03'">
                  <!--日期组件-->
                  <el-date-picker
                    popper-class="DataGrid-BOX"
                    :format="condi.format"
                    :style="{ width: condi.width ? condi.width + 'px' : '150px' }"
                    value-format="yyyy-MM-dd"
                    size="small"
                    v-model="condi.searchValue"
                    type="date"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-else-if="condi.controlTypeName === '04' && condi.opName === 'between'">
                  <!--日期时间组件(范围)-->
                  <Row>
                    <Col>
                      <el-date-picker
                        popper-class="DataGrid-BOX"
                        @change="compareDateTime(condi, 1)"
                        :style="{ width: condi.width ? condi.width + 'px' : '210px' }"
                        :format="condi.format"
                        :value-format="condi.format"
                        size="small"
                        v-model="condi.start"
                        type="datetime"
                        placeholder="开始时间"
                      ></el-date-picker>
                    </Col>
                    <Col style="text-align: center" class="timeTextzhi">&nbsp;至&nbsp;</Col>
                    <Col>
                      <el-date-picker
                        popper-class="DataGrid-BOX"
                        @change="compareDateTime(condi, 2)"
                        :style="{ width: condi.width ? condi.width + 'px' : '210px' }"
                        :format="condi.format"
                        :value-format="condi.format"
                        size="small"
                        v-model="condi.end"
                        type="datetime"
                        placeholder="结束时间"
                      ></el-date-picker>
                    </Col>
                  </Row>
                </template>
                <template v-else-if="condi.controlTypeName === '04'">
                  <!--日期时间组件(普通)-->
                  <el-date-picker
                    popper-class="DataGrid-BOX"
                    :format="condi.format"
                    :style="{ width: condi.width ? condi.width + 'px' : '210px' }"
                    :value-format="condi.format"
                    size="small"
                    v-model="condi.searchValue"
                    type="datetime"
                    placeholder="选择时间"
                  ></el-date-picker>
                </template>
                <template v-else-if="condi.controlTypeName === '07'">
                  <!--月份组件(普通)-->
                  <el-date-picker
                    popper-class="DataGrid-BOX"
                    :format="condi.format"
                    :style="{ width: condi.width ? condi.width + 'px' : '210px' }"
                    value-format="yyyy-MM"
                    size="small"
                    v-model="condi.searchValue"
                    type="month"
                    placeholder="选择月份"
                  ></el-date-picker>
                </template>
                <template v-else-if="condi.controlTypeName === '08'">
                  <!--区域多选带复选框组件(普通)-->
                  <sd-area-select-new ref="refCascader" :style="{ width: condi.width ? condi.width + 'px' : '210px' }" v-model="condi.searchValue" />
                </template>
                <template v-else-if="condi.controlTypeName === '09'">
                  <!--机构组件(普通)-->
                  <sd-cascader ref="sdCascader" :style="{ width: condi.width ? condi.width + 'px' : '210px' }" v-model="condi.searchValue" />
                </template>
                <template v-else-if="condi.controlTypeName === '10'">
                  <!--单位组件(普通-多选)-->
                  <sd-area-tree-select-new ref="refSdTreeSelect" :style="{ width: condi.width ? condi.width + 'px' : '210px' }" v-model="condi.searchValue" />
                </template>
                <template v-else-if="condi.controlTypeName === '11'">
                  <!--案由组件(普通)-->
                  <sd-ay-tree-select ref="refSdAyTreeSelect" :ajlx="params.ajlx ? params.ajlx : '02'" :style="{ width: condi.width ? condi.width + 'px' : '210px' }" v-model="condi.searchValue" />
                </template>
                <template v-else-if="condi.opName === 'between'">
                  <!--范围查询-->
                  <Row>
                    <Col>
                      <Input @on-enter="query_grid_data(1)" :style="{ width: condi.width ? condi.width + 'px' : '150px' }" v-model="condi.start" :key="idx" placeholder="输入起始值" />
                    </Col>
                    <Col style="text-align: center" class="timeTextzhi">&nbsp;至&nbsp;</Col>
                    <Col>
                      <Input @on-enter="query_grid_data(1)" :style="{ width: condi.width ? condi.width + 'px' : '150px' }" v-model="condi.end" :key="idx" placeholder="输入结束值" />
                    </Col>
                  </Row>
                </template>
                <template v-else>
                  <!--文本框-->
                  <Input
                    @on-enter="query_grid_data(1)"
                    :style="{ width: condi.width ? condi.width + 'px' : '100%' }"
                    v-model="condi.searchValue"
                    :key="idx"
                    placeholder=""
                    @input.native="condi.triggerMethod == 'input' ? query_grid_data(1) : null"
                    @change.native="condi.triggerMethod == 'change' ? query_grid_data(1) : null"
                    @blur.native.capture="condi.triggerMethod == 'blur' ? query_grid_data(1) : null"
                  />
                </template>
              </template>
            </FormItem>
          </div>
          <div class="btnBox">
            <Button class="button btn1" type="primary" @click="query_grid_data(1)">查询</Button>
            <Button class="button btn" type="primary" @click="reset_query_condis()">重置</Button>
            <Button v-if="showCustomQuery" class="button btn2" type="primary" @click="customSearch">自定义查询</Button>
          </div>
        </div>
      </Form>

      <!-- 查询-普通查询 -->
      <Form class="formbox" v-if="displayQuery && searchShow && searchType === '01'" :label-width="labelWidth" @submit.native.prevent>
        <template v-for="(condis, index) in queryFields">
          <div class="searchBox" :class="'style' + comModelProps.queryLineNums" :key="index">
            <div v-for="(condi, idx) in condis" :key="idx">
              <FormItem :label="condi.description + '：'">
                <slot :name="condi.queryId" v-if="$scopedSlots[condi.queryId]" :condi="condi"></slot>
                <template v-else>
                  <template v-if="condi.controlTypeName === '02' && (condi.dicType === '0' || condi.dicType === '1')">
                    <!--字典组件-->
                    <s-dicgrid
                      v-model="condi.searchValue"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      ref="dicGrid"
                      :key="idx"
                      :multiple="condi.isDicMultiple"
                      :dicName="condi.dicInfo"
                    />
                  </template>
                  <template v-else-if="condi.controlTypeName === '02' && condi.dicType === '3'">
                    <!--字典组件(下拉框)-->
                    <Select v-model="condi.searchValue" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }" :multiple="condi.isDicMultiple" clearable placeholder="请选择">
                      <Option v-for="item in condi.option" :value="item.key" :key="item.key">{{ item.text }}</Option>
                    </Select>
                  </template>
                  <template v-else-if="condi.controlTypeName === '03' && condi.opName === 'between'">
                    <!--日期组件-->
                    <Row>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :picker-options="pickerOptions(condi, 1)"
                          :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                          :format="condi.format"
                          value-format="yyyy-MM-dd"
                          size="small"
                          v-model="condi.start"
                          type="date"
                          placeholder="开始日期"
                        ></el-date-picker>
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :picker-options="pickerOptions(condi, 2)"
                          :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                          :format="condi.format"
                          value-format="yyyy-MM-dd"
                          size="small"
                          v-model="condi.end"
                          type="date"
                          placeholder="结束日期"
                        ></el-date-picker>
                      </Col>
                    </Row>
                  </template>
                  <template v-else-if="condi.controlTypeName === '03'">
                    <!--日期组件-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      :format="condi.format"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      value-format="yyyy-MM-dd"
                      size="small"
                      v-model="condi.searchValue"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '04' && condi.opName === 'between'">
                    <!--日期时间组件-->
                    <Row>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          @change="compareDateTime(condi, 1)"
                          :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                          :format="condi.format"
                          :value-format="condi.format"
                          size="small"
                          v-model="condi.start"
                          type="datetime"
                          placeholder="开始时间"
                        ></el-date-picker>
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          @change="compareDateTime(condi, 2)"
                          :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                          :format="condi.format"
                          :value-format="condi.format"
                          size="small"
                          v-model="condi.end"
                          type="datetime"
                          placeholder="结束时间"
                        ></el-date-picker>
                      </Col>
                    </Row>
                  </template>
                  <template v-else-if="condi.controlTypeName === '04'">
                    <!--日期时间组件-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      :format="condi.format"
                      :value-format="condi.format"
                      size="small"
                      v-model="condi.searchValue"
                      type="datetime"
                      placeholder="选择时间"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '07'">
                    <!--月份组件(普通)-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      :format="condi.format"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      value-format="yyyy-MM"
                      size="small"
                      v-model="condi.searchValue"
                      type="month"
                      placeholder="选择月份"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '08'">
                    <!--区域组件(普通)-->
                    <sd-area-select-new ref="refCascader" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '09'">
                    <!--机构组件(普通)-->
                    <sd-cascader ref="sdCascader" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '10'">
                    <!--单位组件(普通-多选)-->
                    <sd-area-tree-select-new ref="refSdTreeSelect" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '11'">
                    <!--案由组件(普通)-->
                    <sd-ay-tree-select
                      ref="refSdAyTreeSelect"
                      :ajlx="params.ajlx ? params.ajlx : '02'"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      v-model="condi.searchValue"
                    />
                  </template>
                  <template v-else-if="condi.opName === 'between'">
                    <!--范围查询-->
                    <Row>
                      <Col span="11">
                        <Input
                          @on-enter="query_grid_data(1)"
                          :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                          v-model="condi.start"
                          :key="idx"
                          placeholder="输入起始值"
                        />
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <Input @on-enter="query_grid_data(1)" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }" v-model="condi.end" :key="idx" placeholder="输入结束值" />
                      </Col>
                    </Row>
                  </template>
                  <template v-else>
                    <!--文本框-->
                    <Input
                      @on-enter="query_grid_data(1)"
                      :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '100%' }"
                      v-model="condi.searchValue"
                      :key="idx"
                      placeholder=""
                      @input.native="condi.triggerMethod == 'input' ? query_grid_data(1) : null"
                      @change.native="condi.triggerMethod == 'change' ? query_grid_data(1) : null"
                      @blur.native.capture="condi.triggerMethod == 'blur' ? query_grid_data(1) : null"
                    />
                  </template>
                </template>
              </FormItem>
            </div>
          </div>
        </template>
        <div class="btnBox" style="text-align: center">
          <Button class="button btn" style="font-size: 15px; padding: 0 12px" type="primary" @click="reset_query_condis()">重置</Button>
          <Button class="button btn1" style="font-size: 15px; padding: 0 12px" type="primary" @click="query_grid_data(1)">查询</Button>
          <Button v-if="showCustomQuery" class="button btn2" type="primary" @click="customSearch">自定义查询</Button>
        </div>
      </Form>
      <!-- 查询-综合查询 -->
      <Form class="formbox" v-if="displayQuery && searchShow && searchType === '03'" :label-width="labelWidth" @submit.native.prevent>
        <template v-for="(condis, index) in queryFields">
          <div class="searchBox" :class="'style' + comModelProps.queryLineNums" :key="index+'zhcx'">
            <div v-for="(condi, idx) in condis" :key="idx" :style="{ width: condi.width && condi.width > 1 ? condi.width + '%' : '31%' }">
              <FormItem :label="condi.description + '：'">
                <slot :name="condi.queryId" v-if="$scopedSlots[condi.queryId]" :condi="condi"></slot>
                <template v-else>
                  <template v-if="condi.controlTypeName === '02' && (condi.dicType === '0' || condi.dicType === '1')">
                    <!--字典组件-->
                    <s-dicgrid v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '02' && condi.dicType === '3'">
                    <!--字典组件(下拉框)-->
                    <Select v-model="condi.searchValue" style="width: 100%" :multiple="condi.isDicMultiple" clearable placeholder="请选择">
                      <Option v-for="item in condi.option" :value="item.key" :key="item.key">{{ item.text }}</Option>
                    </Select>
                  </template>
                  <template v-else-if="condi.controlTypeName === '13' && (condi.dicType === '0' || condi.dicType === '1')">
                    <!--多选组件-->
                    <data-checkbox v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '12' && (condi.dicType === '0' || condi.dicType === '1')">
                    <!--单选组件-->
                    <data-radio v-model="condi.searchValue" style="width: 100%" ref="dicGrid" :key="idx" :multiple="condi.isDicMultiple" :dicName="condi.dicInfo" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '03' && condi.opName === 'between'">
                    <!--日期组件-->
                    <Row>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :picker-options="pickerOptions(condi, 1)"
                          style="width: 100%"
                          :format="condi.format"
                          value-format="yyyy-MM-dd"
                          size="small"
                          v-model="condi.start"
                          type="date"
                          placeholder="开始日期"
                        ></el-date-picker>
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          :picker-options="pickerOptions(condi, 2)"
                          style="width: 100%"
                          :format="condi.format"
                          value-format="yyyy-MM-dd"
                          size="small"
                          v-model="condi.end"
                          type="date"
                          placeholder="结束日期"
                        ></el-date-picker>
                      </Col>
                    </Row>
                  </template>
                  <template v-else-if="condi.controlTypeName === '03'">
                    <!--日期组件-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      :format="condi.format"
                      style="width: 100%"
                      value-format="yyyy-MM-dd"
                      size="small"
                      v-model="condi.searchValue"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '04' && condi.opName === 'between'">
                    <!--日期时间组件-->
                    <Row>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          @change="compareDateTime(condi, 1)"
                          style="width: 100%"
                          :format="condi.format"
                          :value-format="condi.format"
                          size="small"
                          v-model="condi.start"
                          type="datetime"
                          placeholder="开始时间"
                        ></el-date-picker>
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <el-date-picker
                          popper-class="DataGrid-BOX"
                          @change="compareDateTime(condi, 2)"
                          style="width: 100%"
                          :format="condi.format"
                          :value-format="condi.format"
                          size="small"
                          v-model="condi.end"
                          type="datetime"
                          placeholder="结束时间"
                        ></el-date-picker>
                      </Col>
                    </Row>
                  </template>
                  <template v-else-if="condi.controlTypeName === '04'">
                    <!--日期时间组件-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      style="width: 100%"
                      :format="condi.format"
                      :value-format="condi.format"
                      size="small"
                      v-model="condi.searchValue"
                      type="datetime"
                      placeholder="选择时间"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '07'">
                    <!--月份组件(普通)-->
                    <el-date-picker
                      popper-class="DataGrid-BOX"
                      :format="condi.format"
                      style="width: 100%"
                      value-format="yyyy-MM"
                      size="small"
                      v-model="condi.searchValue"
                      type="month"
                      placeholder="选择月份"
                    ></el-date-picker>
                  </template>
                  <template v-else-if="condi.controlTypeName === '08'">
                    <!--区域组件(普通)-->
                    <sd-area-select-new ref="refCascader" style="width: 100%" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '09'">
                    <!--机构组件(普通)-->
                    <sd-cascader ref="sdCascader" style="width: 100%" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '10'">
                    <!--单位组件(普通-多选)-->
                    <sd-area-tree-select-new ref="refSdTreeSelect" style="width: 100%" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.controlTypeName === '11'">
                    <!--案由组件(普通)-->
                    <sd-ay-tree-select ref="refSdAyTreeSelect" :ajlx="params.ajlx ? params.ajlx : '02'" style="width: 100%" v-model="condi.searchValue" />
                  </template>
                  <template v-else-if="condi.opName === 'between'">
                    <!--范围查询-->
                    <Row>
                      <Col span="11">
                        <Input @on-enter="query_grid_data(1)" style="width: 100%" v-model="condi.start" :key="idx" placeholder="输入起始值" />
                      </Col>
                      <Col span="2" style="text-align: center" class="timeTextzhi">至</Col>
                      <Col span="11">
                        <Input @on-enter="query_grid_data(1)" style="width: 100%" v-model="condi.end" :key="idx" placeholder="输入结束值" />
                      </Col>
                    </Row>
                  </template>
                  <template v-else>
                    <!--文本框-->
                    <Input
                      @on-enter="query_grid_data(1)"
                      style="width: 100%"
                      v-model="condi.searchValue"
                      :key="idx"
                      placeholder=""
                      @input.native="condi.triggerMethod == 'input' ? query_grid_data(1) : null"
                      @change.native="condi.triggerMethod == 'change' ? query_grid_data(1) : null"
                      @blur.native.capture="condi.triggerMethod == 'blur' ? query_grid_data(1) : null"
                    />
                  </template>
                </template>
              </FormItem>
            </div>
          </div>
        </template>
        <div class="btnBox" style="text-align: center">
          <Button class="button btn" style="font-size: 15px; padding: 0 12px" type="primary" @click="reset_query_condis()">重置</Button>
          <Button class="button btn1" style="font-size: 15px; padding: 0 12px" type="primary" @click="query_grid_data(1, 'cx')">查询</Button>
          <Button class="button btn2" type="primary" @click="resetSearch">高级查询</Button>
          <Button v-if="showCustomQuery" class="button btn2" type="primary" @click="customSearch">自定义查询</Button>
        </div>
      </Form>
      <div class="search-content" v-if="displayQuery && searchShow && searchType === '03'">
        <p class="search-content-select"><span>已筛选条件：</span><Button type="error" @click="closeAll">清空</Button></p>
        <div class="search-content-select-main">
          <template v-for="(ele, order) in complexQueryConfig">
            <p
              class="select-content"
              :key="order + '_' + index"
              v-if="item.searchValue || (item.opName == 'between' && (item.start || item.end))"
              v-for="(item, index) in ele.fields"
              closable
              style="display: flex; align-items: center; font-size: 14px !important"
            >
              <span style="min-width: 80px; display: inline-block; font-size: 14px" class="textOverflowBsp" :title="item.label"
                >{{ item.label }}:<i v-if="item.searchValue && !item.dicInfo" style="font-size: 16px">{{ item.searchValue }}</i>
                <i v-if="item.start"> {{ formatTime(item.start) }}-</i><i v-if="item.end">{{ formatTime(item.end) }}</i>
              </span>
              <!-- 字典 -->
              <s-dicgrid v-if="item.searchValue && item.dicInfo" disabled v-model="item.searchValue" :multiple="item.isDicMultiple" :dicName="item.dicInfo" />
              &nbsp;&nbsp;&nbsp;<Icon type="md-close-circle" @click="closeItem(order, index, item)" />
            </p>
          </template>
        </div>
      </div>

      <!-- 头部操作 -->
      <div :class="['titleNav', quickFilter && quickFilter.length > 0 ? 'hale' : 'nohale']" v-if="(quickFilter && quickFilter.length > 0) || (headOper && headOper.length > 0 && showOper)">
        <div class="navleft">
          <!-- 头操作-自定义 -->
          <div v-if="customFunc && showOper">
            <slot :func="funcAuth" name="customHeadFunc"></slot>
            <template v-for="oper in headOper" v-if="!isAuth(oper.auth)">
              <template v-if="oper.operType === 'EXPORT'">
                <Button @click="headExportOper()" :key="oper.id + 'key'" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-log-out'" size="18" />{{ oper.name }}
                </Button>
                <Button @click="headDataExport()" v-if="asyncExportTotal > 0" key="DATAEXPORTKey" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-download'" size="18" />导出数据下载
                </Button>
              </template>
              <template v-if="oper.operType === 'PRINT'">
                <Button @click="headPrintOper()" :key="oper.id + 'key'" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-print'" size="18" />{{ oper.name }}
                </Button>
              </template>
            </template>
          </div>

          <!-- 头操作-自动生成 -->
          <template v-if="!customFunc && showOper">
            <template v-for="oper in headOper" v-if="!isAuth(oper.auth)">
              <slot :name="oper.mark" v-if="$scopedSlots[oper.mark]" :oper="oper"></slot>
              <template v-else-if="oper.operType === 'ADD'">
                <Button @click="headAddOper(oper.mark)" type="primary" :key="oper.id" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-add'" size="18" />{{ oper.name }}
                </Button>
              </template>
              <template v-else-if="oper.operType === 'DELETE'">
                <Button @click="headDeleteOper(oper.mark, oper.url)" type="error" :key="oper.id" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'ios-trash-outline'" size="18" />{{ oper.name }}
                </Button>
              </template>
              <template v-else-if="oper.operType === 'REFRESH'">
                <Button @click="headRefreshOper(1)" :key="oper.id" class="head-btn"> <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-refresh'" size="18" />{{ oper.name }} </Button>
              </template>
              <template v-else-if="oper.operType === 'EXPORT'">
                <Button @click="headExportOper()" :key="oper.id" class="head-btn"> <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-log-out'" size="18" />{{ oper.name }} </Button>
                <Button @click="headDataExport()" v-if="asyncExportTotal > 0" key="DATAEXPORT" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-download'" size="18" />导出数据下载
                </Button>
              </template>
              <template v-else-if="oper.operType === 'DATAEXPORT'">
                <Button @click="headDataExport()" :key="oper.id" class="head-btn"> <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-log-out'" size="18" />{{ oper.name }} </Button>
              </template>
              <template v-else-if="oper.operType === 'PRINT'">
                <Button @click="headPrintOper()" :key="oper.id + 'key'" class="head-btn">
                  <Icon class="Iconclass" :type="oper.iconPath ? oper.iconPath : 'md-print'" size="18" />{{ oper.name }}
                </Button>
              </template>
              <template v-else>
                <Button :key="oper.id" type="primary" @click="headDealFunction(oper.mark)" class="head-btn">
                  <Icon class="Iconclass" v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="18" />{{ oper.name }}
                </Button>
              </template>
            </template>

            <!-- 头操作-批量 -->
            <Dropdown v-if="headOperBatch.length > 0" placement="bottom" trigger="click" transfer>
              <Button type="info" style="font-size: 15px; margin-right: 10px; margin-top: 5px"> 操 作<Icon size="20" style="margin-left: 2px" type="ios-arrow-down"></Icon> </Button>
              <DropdownMenu slot="list" style="text-align: center" class="data-grid-bsp">
                <template v-for="(oper, idx) in headOperBatch" v-if="!isAuth(oper.auth)">
                  <slot :name="oper.mark" v-if="$scopedSlots[oper.mark]" :oper="oper"></slot>
                  <template v-else-if="oper.operType === 'ADD'">
                    <DropdownItem @click.native="headAddOper(oper.mark)" :key="idx" :divided="idx > 0">
                      <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                    </DropdownItem>
                  </template>
                  <template v-else-if="oper.operType === 'DELETE'">
                    <DropdownItem @click.native="headDeleteOper(oper.mark, oper.url)" :key="idx" :divided="idx > 0">
                      <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                    </DropdownItem>
                  </template>
                  <template v-else-if="oper.operType === 'REFRESH'">
                    <DropdownItem @click.native="headRefreshOper(1)" :key="idx" :divided="idx > 0">
                      <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                    </DropdownItem>
                  </template>
                  <template v-else-if="oper.operType === 'EXPORT'">
                    <DropdownItem @click.native="headExportOper()" :key="idx" :divided="idx > 0">
                      <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                    </DropdownItem>
                  </template>
                  <template v-else>
                    <DropdownItem @click.native="headDealFunction(oper.mark)" :key="idx" :divided="idx > 0">
                      <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                    </DropdownItem>
                  </template>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
        </div>

        <!-- 快速筛选-分组 -->
        <div class="navright" v-if="quickFilter && quickFilter.length > 0 && rightShowTabs">
          <template v-for="(filters, index) in quickFilter">
            <div class="navlist" :class="{ After: index > 0 }" :key="'filter_div' + index">
              <span
                v-for="(item, idx) in filters"
                :key="'filter' + item.id"
                :class="{ active: item.isDefault === '1' }"
                @click="change_quick_filter(index, idx, item.label)"
                :match="item.groupMatchValue"
              >
                {{ item.label }}<template v-if="comModel.groupStat">({{ item.groupNum ? item.groupNum : 0 }})</template>
              </span>
            </div>
          </template>
        </div>
      </div>

      <!-- 表格内容 :height="gridData && gridData.length > 0 ? dataGridHeight : '85px'"-->
      <div style="width: 100%" :id="dataGridId" ref="scrollWrapper" class="scroll-wrapper" v-if="errorMsg === ''">
        <!-- 可视区域的Table：只渲染当前看到的行gridData  renderData-->
          <Table
            :loading="loading"
            tooltip-theme="light"
            :tooltip-max-width="300"
            :height="gridHeight"
            @on-row-dblclick="on_row_dblclick"
            @on-sort-change="on_sort_change"
            @on-row-click="on_row_click"
            @on-selection-change="on_batch_select"
            :columns="dataGridColumns"
            :data="gridData"
            stripe
            border
            ref="sdtable"
          >
            <!-- 表格内容-行索引 -->
            <template slot-scope="{ row, index }" :slot="sc.slot" v-for="sc in slotColumn">
              <slot :name="'slot_' + sc.slot" :row="row" :index="index"></slot>
            </template>

            <!-- 表格内容-行操作 -->
            <template slot-scope="{ row, index }" slot="action">
              <!-- 行操作-自定义 -->
              <slot name="customRowFunc" :func="funcAuth" :row="row" :index="index" v-if="customFunc && showOper"></slot>

              <!-- 行操作-自动生成 -->
              <template v-if="!customFunc && showOper">
                <template v-for="oper in rowOper" v-if="!isAuth(oper.auth)">
                  <slot :name="oper.mark" v-if="$scopedSlots[oper.mark]" :row="row" :index="index" :oper="oper"></slot>
                  <!-- 新增 -->
                  <template v-else-if="oper.operType === 'ADD'">
                    <Button @click="rowAddOper(row, index, oper.mark)" :key="oper.id" size="small" style="margin-right: 4px">
                      <Icon v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="15" />
                      {{ oper.name }}
                    </Button>
                  </template>
                  <!-- 删除 -->
                  <template v-else-if="oper.operType === 'DELETE'">
                    <Button @click="rowDeleteOper(row, index, oper.mark, oper.url)" type="error" :key="oper.id" size="small" style="margin-right: 4px">
                      <Icon v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="15" />
                      {{ oper.name }}
                    </Button>
                  </template>
                  <!-- 修改 -->
                  <template v-else-if="oper.operType === 'MODIFY'">
                    <Button @click="rowModifyOper(row, index, oper.mark)" type="primary" :key="oper.id" size="small" style="margin-right: 4px">
                      <Icon v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="15" />
                      {{ oper.name }}
                    </Button>
                  </template>
                  <!-- 详情 -->
                  <template v-else-if="oper.operType === 'DETAIL'">
                    <Button @click="rowDetailOper(row, index, oper.mark)" :key="oper.id" size="small" style="margin-right: 4px" type="primary">
                      <Icon v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="15" />
                      {{ oper.name }}
                    </Button>
                  </template>
                  <!-- 其它 -->
                  <template v-else>
                    <Button @click="rowDealFunction(row, index, oper.mark)" :key="oper.id" size="small" style="margin-right: 4px" type="primary">
                      <Icon v-if="notEmpty(oper.iconPath)" :type="oper.iconPath" size="15" />
                      {{ oper.name }}
                    </Button>
                  </template>
                </template>

                <!-- 行操作-批量 -->
                <Dropdown v-if="rowOperBatch.length > 0" trigger="click" transfer :placement="index > 5 ? 'top' : 'bottom'">
                  <Button type="info" size="small"> 操 作<Icon type="ios-arrow-down"></Icon> </Button>
                  <DropdownMenu slot="list" class="data-grid-bsp">
                    <template v-for="(oper, idx) in rowOperBatch">
                      <slot :name="oper.mark" :row="row" :index="idx" :oper="oper" v-if="$scopedSlots[oper.mark]"></slot>
                      <!-- 新增 -->
                      <template v-else-if="oper.operType === 'ADD'">
                        <DropdownItem :key="idx" :divided="idx > 0" @click.native="rowAddOper(row, index, oper.mark)" :disabled="isAuth(oper.auth)">
                          <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />
                          {{ oper.name }}
                        </DropdownItem>
                      </template>
                      <!-- 删除 -->
                      <template v-else-if="oper.operType === 'DELETE'">
                        <DropdownItem :key="idx" :divided="idx > 0" @click.native="rowDeleteOper(row, index, oper.mark, oper.url)" :disabled="isAuth(oper.auth)">
                          <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                        </DropdownItem>
                      </template>
                      <!-- 修改 -->
                      <template v-else-if="oper.operType === 'MODIFY'">
                        <DropdownItem :key="idx" :divided="idx > 0" @click.native="rowModifyOper(row, index, oper.mark)" :disabled="isAuth(oper.auth)">
                          <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}1
                        </DropdownItem>
                      </template>
                      <!-- 详情 -->
                      <template v-else-if="oper.operType === 'DETAIL'">
                        <DropdownItem :key="idx" :divided="idx > 0" @click.native="rowDetailOper(row, index, oper.mark)" :disabled="isAuth(oper.auth)">
                          <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                        </DropdownItem>
                      </template>
                      <!-- 其它 -->
                      <template v-else>
                        <DropdownItem :key="idx" :divided="idx > 0" @click.native="rowDealFunction(row, index, oper.mark)" :disabled="isAuth(oper.auth)">
                          <Icon v-if="notEmpty(oper.iconPath)" style="margin-right: 6px" :type="oper.iconPath" size="18" />{{ oper.name }}
                        </DropdownItem>
                      </template>
                    </template>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </template>
          </Table>
      </div>

      <!-- 表格加载异常信息 -->
      <div style="text-align: center" v-else-if="errorMsg !== ''">
        {{ errorMsg }}
      </div>

      <!-- 底部行(数据量、表格筛选、列表设置、字典代码管理) -->
      <template style="margin: 20px 0" v-if="dataGridLoad">
        <div class="page_box">
          <span v-if="showCheckbox" class="page-Data"
            >共选中<i>{{ batch_select.length }}</i
            >条数据</span
          >
          <div class="" style="float: right">
            <Page
              :total="totalNum"
              v-if="pageSearch"
              @on-change="change_page"
              :current="pageNo"
              @on-page-size-change="change_aage_size"
              :page-size="pageSize"
              :page-size-opts="pageSizeOpts"
              size="small"
              show-elevator
              show-sizer
              style="display: inline-block; margin: 10px 0"
            />
            <span class="Total">共 {{ totalNum }} 条 </span>
            <span class="page-btn custom" @click="multi_col_sort" v-if="comModel.customShowField">
              <span>自定义列</span>
              <Modal :width="600" v-model="showModal" :closable="false" :mask-closable="false" class-name="user-selector-modal">
                <div class="flow-modal-title" slot="header">
                  <span style="font-size: 17px !important">自定义列<span style="font-size: 14px; padding-left: 15px">勾选需要显示的列，拖动列名进行排序</span></span>
                  <span @click="handleCancel" style="position: absolute; right: 6px; font-size: 32px; cursor: pointer">
                    <i class="ivu-icon ivu-icon-ios-close"></i>
                  </span>
                </div>
                <div>
                  <ul class="list">
                    <li
                      @dragenter="dragenter($event, index)"
                      @dragover="dragover($event, index)"
                      @dragstart="dragstart(index)"
                      draggable
                      v-for="(item, index) in customShowList"
                      :key="item.label"
                      class="list-item"
                    >
                      <div class="ele1">{{ index + 1 }}</div>
                      <div class="ele2" :style="{ color: item.require ? '#999999' : '#3E4E66' }">
                        <Checkbox :disabled="item.require" v-model="item.check">{{ item.label }} </Checkbox>
                      </div>
                      <div class="ele3">{{ item.require ? '(必选)' : '' }}</div>
                    </li>
                  </ul>
                </div>
                <div class="footer-container" slot="footer">
                  <Button class="cancle-button" @click="handleSet" style="background: #fff">恢复默认</Button>
                  <Button type="error" class="set-button" @click="handleCancel">关 &nbsp;闭</Button>
                  <Button type="primary" class="submit-button" @click="handleSubmit">保&nbsp;存</Button>
                </div>
              </Modal>
            </span>
            <span class="page-btn" @click="multi_col_set()" v-if="!comModel.customShowField">
              <span>多列筛选</span>
              <div class="ulnavlist" v-if="multiColSetShow" @mouseleave="multiColSetShow = false">
                <ul class="" style="width: 100%; height: 258px; overflow-y: auto">
                  <li
                    v-for="(col, index) in column"
                    v-show="col.isColumnFiltering === '1'"
                    @click.stop="multi_col_change(index)"
                    :key="'col_' + index"
                    :class="{ active: col.show }"
                    :title="col.title"
                  >
                    <i class="iconlist"></i>
                    {{ col.title }}
                  </li>
                </ul>
                <div style="text-align: center; margin-top: 16px; bottom: 1px">
                  <!-- style="text-align: left; font-size: 14px; color: #2db7f5;" -->
                  <Button class="saveBtn-dlsx" type="primary" shape="circle" @click.stop="saveCustom()">保 存</Button>&nbsp;
                  <Button class="saveBtn-dlsx" shape="circle" @click.stop="resetCustom()">重 置</Button>
                </div>
              </div>
            </span>
            <span class="page-set" v-if="$store.getters.isSAdmin" title="列表设置" @click="openSetPage($store.getters.token)" style="cursor: pointer; margin-right: -10px">
              <Icon type="ios-settings" size="22" />
            </span>
            <span class="page-set" v-if="showDicManage" title="字典代码管理" @click="openDicManage($store.getters.token)" style="cursor: pointer; margin-right: -10px">
              <Divider type="vertical" />
              <Icon type="ios-construct" size="22" />
            </span>
          </div>
        </div>
      </template>
    </div>
    <div v-if="modalStatus">
      <component v-bind:is="iframeComponent" @closeModal="closeModal" :modalWidth="modalWidth" :modalHeight="modalHeight" :title="modalTitle" :iframeUrl="iframeUrl" :modalId="modalId"></component>
    </div>
    <grid-export-opt
      v-if="gridExportOptStatus"
      :gridAllShowFields="modelShowFields"
      :modalWidth="modalWidth"
      :selectedRows="batch_select"
      :rowMark="comModelProps.rowMark"
      :gridRequestParams="gridExportDataRequestParams"
      :pageSize="pageSize"
      :exportMaxCount="exportMaxCount"
      @closeModal="closeExportOptModal"
    />
    <grid-data-opt v-if="gridExportDataStatus" :gridRequestParams="gridDataRequestParams" :rowMark="comModelProps.rowMark" :modalWidth="modalWidth" @closeModal="closeDataOptModal" />
    <grid-print-opt
      v-if="gridPrintOptStatus"
      :gridAllShowFields="modelShowFields"
      :modalWidth="modalWidth"
      :selectedRows="batch_select"
      :rowMark="comModelProps.rowMark"
      :modelName="comModel.name"
      :gridRequestParams="gridPrintDataRequestParams"
      :pageSize="pageSize"
      :exportMaxCount="exportMaxCount"
      @closeModal="closePrintOptModal"
    />
    <Modal v-model="openDicModal" :mask-closable="false" :closable="true" width="80%" :title="dicModalTitle" :footer-hide="true" :scrollable="true">
      <dic-manage v-if="openDicModal" :dicNames="comModelProps.dicNames" :isRefApp="comModelProps.dicRefApp" />
    </Modal>
    <girdMoreSearch ref="girdMoreSearch" :complexQueryConfig="complexQueryConfig" :comModelProps="comModelProps" :labelWidth="labelWidth" @confirmSearch="confirmSearch" />
    <s-dialog v-show="sDialogShow"  :dialogMark='dialogMark' ref="sDialog" :params="paramsDialog" ><template  v-slot:func >
                      <!-- <Button  type="primary" >选择人员</Button> -->
                    </template></s-dialog>
  </div>
</template>
<script>
import dataGrid from '../dataGrid'
import iframeComponent from './iframeComponent.vue'
import gridExportOpt from './grid-export-opt.vue'
import gridDataOpt from './grid-data-opt.vue'
import gridPrintOpt from './grid-print-opt.vue'
import { sdAreaSelectNew } from 'sd-area-select-new'
import { sdCascader } from 'sd-cascader'
import { sdAreaTreeSelectNew } from 'sd-area-tree-select-new'
import { sdAyTreeSelect } from 'sd-ay-tree-select'
import { dicManage } from 'sd-dic-manage'
import girdMoreSearch from './grid-more-search.vue'
import dataCheckbox from './data-checkbox.vue'
import dataRadio from './data-radio.vue'
import { sDialog } from 'sd-custom-dialog'
  //测试点击打开自定义对话框
export default {
  mixins: [dataGrid],
  components: {
    iframeComponent: iframeComponent,
    gridExportOpt: gridExportOpt,
    gridDataOpt: gridDataOpt,
    gridPrintOpt: gridPrintOpt,
    dicManage: dicManage,
    sdAreaSelectNew,
    sdCascader,
    sdAreaTreeSelectNew,
    sdAyTreeSelect,
    girdMoreSearch,
    dataCheckbox,
    dataRadio,sDialog
  },
  computed: {
    pickerOptions() {
      let that = this
      return function (condi, type) {
        return {
          disabledDate(time) {
            if (type === 1) {
              if (condi.end) {
                let licenseEnd = new Date(condi.end)
                licenseEnd.setDate(licenseEnd.getDate())
                return time.getTime() >= licenseEnd
              } else {
                return false
              }
            } else {
              if (condi.start) {
                let licenseStart = new Date(condi.start)
                licenseStart.setDate(licenseStart.getDate() - 1)
                return time.getTime() <= licenseStart
              } else {
                return false
              }
            }
          }
        }
      }
    }
  }
  // beforeDestroy() {
  // 	// 组件销毁前取消所有请求
  // 	this.cancelTokens.forEach(source => {
  // 		source.cancel('组件销毁，取消请求');
  // 	});
  // 	this.cancelTokens = [];
  // }
}
</script>
<style scoped lang="less">
.list {
  list-style: none;
}

.list {
  border-left: 1px solid #cee0f0;
  border-right: 1px solid #cee0f0;
}

.list .list-item,
.ele1 {
  text-align: center;
  width: 60px;
}

.list .list-item,
.ele2 {
  text-align: left;
  flex: 1;
}

.list .list-item,
.ele3 {
  text-align: center;
  width: 80px;
}

.list .list-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 8px;
  cursor: move;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #cee0f0;
  font-size: 16px;
}

.list .list-item:first-child {
  border-top: 1px solid #cee0f0;
}

.list .list-item:hover {
  background: #f0f5ff;
  /* box-shadow: 0px -3px 7px 0px rgba(85,176,255,0.30); */
}

/deep/ .ivu-checkbox-wrapper {
  font-size: 16px;
}

/deep/ .ivu-checkbox-checked .ivu-checkbox-inner {
  background-color: #2b5fd9;
  border-color: #2b5fd9;
}

.list /deep/ .ivu-checkbox-disabled .ivu-checkbox-inner {
  background-color: #b4bccc;
  border-color: #b4bccc;
  color: #ffffff;
}

/deep/ .ivu-checkbox-checked:focus {
  box-shadow: none;
}

/deep/ .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
  border-color: #fff;
}

.user-selector-modal .flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
}

/deep/ .user-selector-modal .ivu-modal-body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

/deep/ .user-selector-modal .ivu-modal-body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d3daeb;
}

/deep/ .user-selector-modal .ivu-modal-body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

/deep/ .user-selector-modal .ivu-modal-body::-webkit-scrollbar-thumb:hover {
  background-color: #b6c0d9;
  cursor: pointer;
}

/deep/ .user-selector-modal .ivu-modal-body::-webkit-scrollbar-button {
  height: 2px;
  width: 2px;
}

/deep/ .user-selector-modal .ivu-modal-body {
  height: 600px;
  max-height: 600px;
  overflow-y: auto;
  padding: 16px !important;
}

/deep/ .user-selector-modal .ivu-modal-header {
  padding: 0 !important;
}

/deep/ .user-selector-modal .ivu-modal-footer {
  height: 50px;
  line-height: 50px;
  background: #f7faff;
  /* padding: 8px 18px 8px 18px; */
  padding: 0 18px;
}

.footer-container {
  text-align: center;
}

.cancle-button {
  background: #ffffff;
  border: 1px solid #2b5fda;
  color: #2b5fda;
}

.set-button {
  background: #f06060;
}

.submit-button {
  background: #2b5fda;
}

.DataGrid-BOX {
  padding: 0px;
}

.DataGrid-BOX .formbox {
  background: #f7f9fc;
  padding: 20px 20px 10px 20px;
  margin-bottom: 10px;
  border: 1px solid #cee0f0;
}

.ivu-btn-primary {
  background: #2b5fd9;
}

.ivu-btn-info {
  background: #316cf5;
}

.DataGrid-BOX .formbox-simple {
  background: #f7f9fc;
  padding: 20px 20px 10px 20px;
  margin-bottom: 10px;
  overflow: hidden;
  border: 1px solid #cee0f0;
}

.DataGrid-BOX .formbox .searchBox,
.DataGrid-BOX .formbox-simple .searchBox {
  display: flex;
  flex-wrap: wrap;
}

.style2 > div {
  width: 50%;
}

.style3 > div {
  width: 33.3%;
}

.style4 > div {
  width: 25%;
}

.style5 > div {
  width: 20%;
}

.DataGrid-BOX /deep/ .ivu-form-item {
  margin-bottom: 10px !important;
}

.DataGrid-BOX /deep/ .ivu-form .ivu-form-item-label {
  width: 60px;
  font-size: 16px;
  padding: 8px 2px 10px 0;
  color: #1a2133;
}

.DataGrid-BOX /deep/ .formbox-simple.ivu-form .ivu-form-item-label {
  padding-top: 10px;
}

.DataGrid-BOX .titleNav .navleft /deep/ .ivu-btn {
  margin-right: 10px;
  font-size: 15px;
  line-height: 30px;
}

.DataGrid-BOX .button {
  margin: 10px;
  border-radius: 4px;
}

.DataGrid-BOX .btn {
  color: #2b5fd9;
  border: 1px solid #2b5fd9;
  background: #fff;
  width: 56px;
  line-height: 30px;
}

.DataGrid-BOX .btn1 {
  background: #2b5fd9;
  color: #fff;
  width: 56px;
  line-height: 30px;
}

.DataGrid-BOX .btn2 {
  background: #17b0fc;
  color: #fff;
}

.DataGrid-BOX .navleft > span {
  display: inline-block;
  padding: 0 12px;
  color: #fff;
  background: #c0c4cc;
  height: 30px;
  line-height: 30px;
  margin: 10px 10px 10px 0;
  border-radius: 2px;
  cursor: pointer;
}

.DataGrid-BOX .titleNav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: -10px;
  line-height: 50px;
  min-height: 2px;
  justify-content: space-between;
}

.DataGrid-BOX .hale > div {
  //   width: 50%;
}

.DataGrid-BOX .nohale > div {
  width: 100%;
}

.DataGrid-BOX .navleft .La {
  background: #3179f5;
}

.DataGrid-BOX .navleft .Lv {
  background: #11c28a;
}

.DataGrid-BOX .navleft .Hong {
  background: #f06060;
}

.DataGrid-BOX .titleNav > div.navright {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.DataGrid-BOX .navright span {
  display: inline-block;
  height: 24px;
  line-height: 16px;
  margin: 8px 8px;
  border-radius: 2px;
  padding: 0 3px;
  cursor: pointer;
  position: relative;
}

.DataGrid-BOX .navright span:hover {
  background: #eff6ff;
}

.DataGrid-BOX .navright .active {
  border-bottom: 3px solid #3179f5;
  color: #2372fa;
}

.DataGrid-BOX .navright .active-a {
  margin-right: 40px;
  position: relative;
}

.DataGrid-BOX .i-data {
  position: absolute;
  display: inline-block;
  background: #e5efff;
  font-style: normal;
  color: #666;
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  top: 6px;
  border-radius: 50px;
  right: -35px;
}

.DataGrid-BOX .common_optation .input,
.DataGrid-BOX .common_optation .select {
  max-width: 300px;
}

.DataGrid-BOX .page-Data,
.DataGrid-BOX .page-set,
.DataGrid-BOX .page-btn {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  vertical-align: top;
  margin: 10px 0 10px 10px;
  font-size: 15px;
}

.DataGrid-BOX .page-Data i {
  font-style: normal;
  color: #2b5fd9;
  margin: 0 5px;
  font-weight: bold;
}

.DataGrid-BOX .page-btn {
  cursor: pointer;
  position: relative;
  padding-left: 20px;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAOtJREFUOE9jZACDBibtuMiHDIwMMhA+keA/w5Ori5bLMzA0/GNkYPjPpB1/6y+RWrEqu7pQjZlRO+7mY5Jdgm7cf4YnjNrxN/9T4hqYXrhBVxaoEWWeTsItrOrgBvFyMTEcn6aC1zDdxFsM/3G4H8Vr6rJsDGubFbAaZp5xh+Hrj384LcIII28LXobODEkUDf7VDxjuPv2F17VYA7syWpQh2lUQrLF0+nOG7Sc/g9nYwhEWZjhjDaYJV+CiO48kg4aJi0DpamePIoNV1l2iEioVswi1Mi1VihFFNWZGSgq2/wwMT68tXC4HKtgAxxpwt8uJc1IAAAAASUVORK5CYII=')
    no-repeat left center;
}

.DataGrid-BOX .custom {
  cursor: pointer;
  position: relative;
  padding-left: 20px;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAATVJREFUOE9jZACDBibtuMiHDIwMMhA+keA/w5Ori5bLMzA0/GNkYPjPpB1/6y+RWrEqu7pQjZlRO+7mY5Jdgm7cf4YnjNrxN/9js8ZOn5uhMFSEIbDmIVh6foUMw6Kd7xn2n/+K1VVYDTo7S4WBnY0Jq4afv/4xGKfdwZDDatCVBWp4g0wn4RadDCoIFWFI8BBkYGFmBNv46/d/BoeCuwz//zMwHJyozMDGChH/8/c/w4Id7xkmrH4DdxmK19C9hO4FfPKD3CCQhx0MuBmmFEiD/Q4Km9jWR2D24mo5BkZIEDFkT3jKcPACanoa5NEPi0trHS6GmSWQgqB46jMGQV5mhpo4cTA/recJw7Er37AkSCIzLTMTA8PffzgSPCjTUqUYUVSDJmEyC7b/DAxPry1cLgcq2AD6t5K3B+tq3QAAAABJRU5ErkJggg==')
    no-repeat left center;
}

.DataGrid-BOX .sx {
  color: blue;
  font-size: 24px;
  color: blue;
  position: absolute;
  margin-top: 2px;
  left: -5px;
}

.DataGrid-BOX .ulnavlist {
  list-style: none;
  border: 1px solid #0394f9;
  position: absolute;
  left: -78px;
  width: 150px;
  bottom: 100%;
  background: #ffffff;
  z-index: 1000;
  height: 310px;
  overflow-y: hidden;
  -webkit-box-shadow: 0px 0px 5px 0px #bebef3;
  box-shadow: 0px 0px 5px 0px #bebef3;
  // position: relative;
}

.DataGrid-BOX .ulnavlist li {
  width: 100%;
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.DataGrid-BOX .navlist {
  position: relative;
  padding: 0 10px;
  font-size: 15px;
}

.DataGrid-BOX .After::after {
  content: '';
  width: 2px;
  height: 24px;
  background: #d5d5d6;
  position: absolute;
  top: 16px;
  left: 0px;
}

.DataGrid-BOX .iconlist {
  font-style: initial;
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1px solid #2b5fd9;
  border-radius: 4px;
  margin: 8px 8px;
  vertical-align: middle;
}

.DataGrid-BOX li.active .iconlist {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABeklEQVQ4ja3U3ytDcRjH8fc5+RXapoxFSrKIe60lSpILUpPQLswF90palJEa7l240FZSygUlN0YUpUm51OQfIIn9yOWmZ2abOrNs53P5/Z7n1fN8zzlfpXPqEcAKbAD9gIH/JQKcA27gqQRoA4KA6Z/QT6QBB9AH2FTAWwSWHTG8ampMvTKgFnBmf6Va1RFLpiDQNVjD7XYrC5Pm4sGpwRrmJ8xUVag4eoz5wfJShZaGMk3M2W9ifjzT1d7Ze37Q527i2NvM+qwFNWt3tNeI21mHoqSwwDtbh29/g/KwtfG7u2G7gdVpS3JtpNuAx1Wfxg4uw2zuv2pOIb9eInthyG7AO2NBTRUHHz7paq9Md3t0HWbZ90IiocVpjHxyE2HFnymwdWQw2fP4c2OaoOTwKsza7u/C07soizvPxOO5MUlJrg05J0VRmBur5eI+luwsH4bWGRYbNXWf6ZWYgHI56pWAgEvAhw6iGEsChuTrkJcLRAuApEZqbUDoC8xYY482/HjCAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}

.DataGrid-BOX .Total {
  display: inline-block;
  height: 24px;
  line-height: 24px;
  vertical-align: top;
  margin: 10px 0px;
  padding: 0 15px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 15px;
}

/deep/ .ivu-table-row-highlight td {
  background-color: #dae5ff !important;
}

/*浮在某行*/
/deep/ .ivu-table-row-hover td {
  background-color: #dae5ff !important;
}

/deep/ .ivu-table-row:hover td {
  background-color: #dae5ff !important;
}

.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
  background: #f7f9fc !important;
}

.DataGrid-BOX /deep/ .ivu-table-border tr td {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #475066;
}

.DataGrid-BOX /deep/ .ivu-table-wrapper {
  overflow: initial;
}

.DataGrid-BOX /deep/ .ivu-table-filter i:hover {
  color: #2b5fd9;
}

/deep/ .ivu-table-sort i.on {
  color: #2b5fd9;
}

.DataGrid-BOX .page_box {
  border: 1px solid #ddd;
  border-top: none;
  padding: 0 20px;
  height: 42px;
}

/*.DataGrid-BOX  .ivu-poptip-content{border: 1px solid #2d8cf0;}*/
.DataGrid-BOX /deep/ .ivu-table th {
  background: #dee9fc;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 16px;
  color: #1f2533;
}

.DataGrid-BOX /deep/ .ivu-table {
  font-size: 16px;
  color: #2b3646;
}

.DataGrid-BOX /deep/ .ivu-table-border th,
.DataGrid-BOX /deep/ .ivu-table-border td {
  border-right: 1px solid #f5f7fa;
}

.DataGrid-BOX /deep/ .ivu-table th,
.DataGrid-BOX /deep/ .ivu-table td {
  height: 40px;
}

.DataGrid-BOX .steylehang .btnBox .button {
  margin: 1px 0px 0px 20px;
  font-size: 16px;
  padding: 0 12px;
}

.DataGrid-BOX .head-btn {
  font-size: 15px;
}

.DataGrid-BOX /deep/ .ivu-table td a {
  color: #2c2cf9;
  text-decoration: none;
  border-bottom: 1px solid;
  cursor: pointer;
}

.DataGrid-BOX /deep/ .ivu-page-item {
  font-size: 15px;
}

.DataGrid-BOX /deep/ .ivu-page-item-active {
  background-color: #2b5fd9 !important;
}

.DataGrid-BOX /deep/ .ivu-page-options-elevator input {
  font-size: 15px;
}

.DataGrid-BOX /deep/ .ivu-page-item-active:hover > a,
.DataGrid-BOX /deep/ .ivu-page-item-active > a {
  color: #fff !important;
}

.DataGrid-BOX /deep/ .ivu-input {
  font-size: 15px;
  border-color: #cee0f0;
}

.DataGrid-BOX /deep/ .ivu-input:focus {
  border-color: #2b5fd9;
  box-shadow: inset 0 0 0 1000px #ffffff !important;
}

.DataGrid-BOX /deep/ .el-input--small .el-input__inner:focus {
  border-color: #2b5fd9;
  box-shadow: inset 0 0 0 1000px #ffffff !important;
}

.DataGrid-BOX /deep/ .el-input__inner {
  border-color: #cee0f0;
}

.DataGrid-BOX /deep/ .ivu-select-selected-value,
.DataGrid-BOX /deep/ .ivu-select-placeholder {
  font-size: 15px !important;
}

.DataGrid-BOX /deep/ .ivu-select-item {
  font-size: 15px !important;
}

.DataGrid-BOX /deep/ .ivu-page-options-elevator {
  font-size: 15px;
}

.DataGrid-BOX /deep/ .el-input {
  font-size: 15px !important;
}

.DataGrid-BOX /deep/ .el-date-table {
  font-size: 15px !important;
}

.DataGrid-BOX /deep/ .ivu-table-overflowY::-webkit-scrollbar,
.DataGrid-BOX /deep/ .ivu-table-overflowX::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.DataGrid-BOX /deep/ .ivu-table-overflowY::-webkit-scrollbar-thumb,
.DataGrid-BOX /deep/ .ivu-table-overflowX::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d3daeb;
}

.DataGrid-BOX /deep/ .ivu-table-overflowY::-webkit-scrollbar-track,
.DataGrid-BOX /deep/ .ivu-table-overflowX::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.DataGrid-BOX /deep/ .ivu-table-overflowY::-webkit-scrollbar-thumb:hover .DataGrid-BOX /deep/ .ivu-table-overflowX::-webkit-scrollbar-thumb:hover {
  background-color: #b6c0d9;
  cursor: pointer;
}

.DataGrid-BOX /deep/ .ivu-table-overflowY::-webkit-scrollbar-button .DataGrid-BOX /deep/ .ivu-table-overflowX::-webkit-scrollbar-button {
  height: 2px;
  width: 2px;
}

.DataGrid-BOX /deep/ .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
}

.ivu-btn-primary.disabled,
.ivu-btn-primary[disabled],
.ivu-btn-info.disabled,
.ivu-btn-info[disabled] {
  color: #c5c8ce;
  background-color: #f7f7f7 !important;
  border-color: #dcdee2;
}

.DataGrid-BOX .btnBox {
  display: flex;
  justify-content: center;
}

.timeTextzhi {
  display: flex;
  justify-content: center;
  align-items: center;
}

.data-grid-bsp {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 10%;
  width: 120px;
}

.data-grid-bsp /deep/ div,
.data-grid-bsp /deep/ .ivu-btn {
  width: 100% !important;
  margin-bottom: 5px;
}

.saveBtn-dlsx {
  width: 55px;
  font-size: 14px;
  line-height: 33px;
  margin-bottom: 5px;
}

.saveBtn-dlsx /deep/ span {
  margin-left: -4px !important;
}
.search-content-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-content-select-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.searchBox.style4 {
  display: flex;
  flex-wrap: wrap;
}
.select-content {
  background: linear-gradient(90deg, #115fc6, #56bbff);
  color: #fff;
  padding: 6px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  cursor: pointer;
  height: 42px;
  i {
    font-style: normal;
  }
}
.select-content /deep/ .sp-base,
.select-content /deep/ .sp-selected-tag {
  background: transparent !important;
  border: none !important;
  color: #fff !important;
}
.select-content /deep/ .sp-button {
  display: none !important;
}
.textOverflowBsp {
  white-space: nowrap;
  /* 禁止文本换行 */
  overflow: hidden;
  /* 隐藏超出范围的内容 */
  text-overflow: ellipsis;
  /* 使用省略号 */
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/components/data-grid.vue